export const LOAD_PROMOTIONS = 'LOAD_PROMOTIONS'
export const ADD_PROMOTION = 'ADD_PROMOTION'
export const SET_CURRENT_PROMOTION = 'SET_CURRENT_PROMOTION'
export const UPDATE_PROMOTION = 'UPDATE_PROMOTION'
export const UPDATE_PROMOTION_STATUS = 'UPDATE_PROMOTION_STATUS'
export const LOAD_APPLIES = 'LOAD_APPLIES'
export const LOAD_DISCOUNT_TYPES = 'LOAD_DISCOUNT_TYPES'
export const APPEND_PROMOTION_NOTIFICATION = 'APPEND_PROMOTION_NOTIFICATION'
export const SET_PENDING_PRODUCTS = 'SET_PENDING_PRODUCTS'